import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntlHlwn70 } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_HLWN70: Record<
  PageIdIntlHlwn70,
  TPageConfig
> = {
  [PageId.OFFER_INTL_HLWN70]: {
    id: PageId.OFFER_INTL_HLWN70,
  },
  [PageId.SPECIAL_DISCOUNT_INTL_HLWN70]: {
    id: PageId.SPECIAL_DISCOUNT_INTL_HLWN70,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.CANCEL_OFFER_INTL_HLWN70]: {
    id: PageId.CANCEL_OFFER_INTL_HLWN70,
  },
  [PageId.PAYMENT_INTL_HLWN70]: {
    id: PageId.PAYMENT_INTL_HLWN70,
  },
  [PageId.CHECKOUT_INTL_HLWN70]: {
    id: PageId.CHECKOUT_INTL_HLWN70,
  },
  [PageId.UPSELL_INTL_HLWN70]: {
    id: PageId.UPSELL_INTL_HLWN70,
  },
  [PageId.REGISTRATION_INTL_HLWN70]: {
    id: PageId.REGISTRATION_INTL_HLWN70,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.NAME_ENTRY_INTL_HLWN70]: {
    id: PageId.NAME_ENTRY_INTL_HLWN70,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.CERTIFICATE_INTL_HLWN70]: {
    id: PageId.CERTIFICATE_INTL_HLWN70,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.LEARNWORLDS_REDIRECT_INTL_HLWN70]: {
    id: PageId.LEARNWORLDS_REDIRECT_INTL_HLWN70,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.REPORT_INTL_HLWN70]: {
    id: PageId.REPORT_INTL_HLWN70,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
}
